import Vue from 'vue';
import Vuetify from 'vuetify';
import {IconConfig} from '@/plugins/icons';
import colors from 'vuetify/lib/util/colors';
import i18n from "@/plugins/i18n";
import {Tenant} from "@/models/ui/Tenant";

Vue.use(Vuetify);

const colorPrimaryHerzog: string = '#eb2918';
const colorPrimaryMk: string = '#db0031';

const colorPrimary = parseInt(process.env.VUE_APP_TENANT) === Tenant.herzog ? colorPrimaryHerzog : colorPrimaryMk;
const colorSecondary: string = '#555';

export default new Vuetify({
	lang: {
		t: (key, ...params) => i18n.t(key, params).toString()
	},
	icons: {
		iconfont: 'faSvg',
		values: IconConfig
	},
	theme: {
		dark: false,
		options: {
			customProperties: true,
		},
		themes: {
			light: {
				//vuetify
				primary: colorPrimary,
				secondary: colorSecondary,
				accent: colorPrimary,
				error: colors.red.lighten1,
				info: colors.blue.base,
				success: colors.green.base,
				warning: colors.orange.base,
				anchor: colorPrimary,

				//common
				default: colors.grey.base,
			},
		}
	},
});
